<!--
 * @Description:自动分配考场地点
 * @Author: WLX
 * @Date: 2023-05-16 13:41:07
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 15:38:12
-->
<template>
    <div class="tan-chuang">
      <el-dialog class="w600 h430" :model-value="openfpjkjsClick" :close-on-click-modal="false" :show-close="false" destroy-on-close>
        <template #header>
          <div class="header-left">
            <el-icon class="header-icon">
              <Edit />
            </el-icon>
            <span class="header-title">自动分配监考教师</span>
          </div>
          <div class="header-right">
            <el-button type="info" text @click="closeWindow('openfpjkjsClick', emits, false)">
              <el-icon>
                <Close />
              </el-icon>
            </el-button>
          </div>
        </template>
        <el-form ref="ruleFormRef" :model="ruleForm" label-width="180px">
          <el-row>
            <el-col :span="24">
              <div>
                考场数:{{kaoChangShu}}  场次数:{{changCiShu}}
              </div>
            </el-col>
            <el-col :span="24">
              <el-form-item label="每个考场监考教师数量" prop="kcjkjssl" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-input-number v-model="ruleForm.kcjkjssl" :min="0" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="监考教师是否相同">
                <el-checkbox v-model="ruleForm.tkcJkjsxt" :label="false">同一考场监考教师相同</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="监考教师" prop="jkjsids" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <!-- 多选 BEGIN -->
                <div class="an-niu wp100">
                  <el-button type="primary" class="w180" @click="openJiaoZhiGongDuoTiao=true;row={ids:jzgiddata}">选择</el-button>
                  <el-button link v-if="jzgdata.length" @click="jzgdata=[];jzgiddata=[]">清空</el-button>
                </div>
                <div class="biao-qian" v-if="jzgdata.length">
                  <el-tag class="mr10 mt10" v-for="(item, index) in jzgdata" :key="index" closable :disable-transitions="false" @close="YiChu(index)">
                    {{ item.xm }}
                  </el-tag>
                </div>
                <!-- 多选 END -->
              </el-form-item>
            </el-col>
            
          </el-row>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
            <div></div>
            <div class="footer_but">
                <el-button type="primary" @click="submit()">保存</el-button>
                <el-button type="info" @click="closeWindow('openfpjkjsClick', emits, false)">关闭</el-button>
            </div>
          </div>
        </template>
      </el-dialog>
    </div>
    <!-- <jiaoxuechangdiduotiao v-if="openlljxcdDuoTiao" v-model:openDuoTiao="openlljxcdDuoTiao" :row="row" @ReturnData="lljxcdReturnData"/> -->
    <jiaozhigongduotiao v-if="openJiaoZhiGongDuoTiao" v-model:openDuoTiao="openJiaoZhiGongDuoTiao" :row="row" @ReturnData="duoTiaoReturnData" />
  </template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { submitForm, closeWindow, loadSelect, actionPost } from '@/api/common.js'
import jiaozhigongduotiao from '@/components/chazhaodaihui/jiaozhigongduotiao.vue'

const props = defineProps({
  openfpjkjsClick: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openfpjkjsClick', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({ tkcJkjsxt: false })

const row = ref()
const kaoChangShu = ref(null)
const changCiShu = ref(null)

// 考场场次数量
const kaoChangChangCiNumber = async () => {
  const o = { url: '/api/v2/jiaowu/kaowukaoshijihuapaikao/kaochangchangcishuliang', data: { pkjhid: ruleForm.value.pkjhid } }
  actionPost(o).then((res) => {
    kaoChangShu.value = res.data.kaoChangShu
    changCiShu.value = res.data.changCiShu
  })
}

watch(
  () => props.openfpjkjsClick,
  () => {
    if (props.openfpjkjsClick) {
      row.value = props.row
      // 
      ruleForm.value.pkjhid = props.row.id || ''

      kaoChangChangCiNumber()
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  ruleForm.value.jkjsids = jzgiddata
  submitForm({
    url: '/api/v2/jiaowu/kaowukaoshijihuapaikao/zidongfenpeijiankaojiaoshi',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openfpjkjsClick', emits, true)
    }
  })
}

// 监考教师
const openJiaoZhiGongDuoTiao = ref(false)
const jzgdata = ref([])
const jzgiddata = ref([])
const duoTiaoReturnData = (data) => {
  jzgdata.value = data || []
  jzgiddata.value = data.map((item) => item.id)
}

// 移出
const YiChu = (index) => {
  jzgdata.value.splice(index, 1)
  jzgiddata.value.splice(index, 1)
}

</script>
